import { cn } from '@divlab/divanui';

import { images } from './images';
import styles from './Benefits.module.css';
import { useRequest } from '@Contexts/Request';
import useTranslation from '@Queries/useTranslation';
import Img from '@UI/Img';

import type { FC, HTMLAttributes } from 'react';

interface Benefit {
  image: string;
  text: string;
}

type BenefitName = 'guarantee' | 'payment' | 'refund' | 'delivery';

const allBenefits: BenefitName[] = ['guarantee', 'payment', 'refund', 'delivery'];

const Benefits: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { country } = useRequest();
  const { t } = useTranslation();
  const isBLR = country === 'BLR';
  const title = t('ui.benefits.title');

  const benefits: Benefit[] = allBenefits
    .map((benefit) => {
      if (isBLR && benefit === 'refund') return;

      return {
        text: t(`ui.benefits.items.${benefit}`),
        image: images[benefit],
      };
    })
    .filter((benefit) => benefit);

  return (
    <div {...props}>
      <div className={styles.benefits}>
        <div className={styles.title}>{title}</div>
        <div
          className={cn(styles.grid, {
            [styles.odd]: benefits.length % 2 !== 0,
            [styles.even]: benefits.length % 2 === 0,
          })}
        >
          {benefits.map((benefit) => {
            return (
              <div key={benefit.text}>
                <Img
                  className={styles.imageContainer}
                  cnImage={styles.image}
                  src={benefit.image}
                  loading='lazy'
                />
                <div className={styles.text}>{benefit.text}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Benefits;
